import { render, staticRenderFns } from "./OrderKanbanView.vue?vue&type=template&id=8305008c&scoped=true&lang=pug&"
import script from "./OrderKanbanView.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanView.vue?vue&type=script&lang=js&"
import style0 from "./OrderKanbanView.vue?vue&type=style&index=0&id=8305008c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8305008c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VContainer,VDivider,VSpacer,VWindow,VWindowItem})
